import styled from 'styled-components';
import { focusOutline } from 'themes/helpers';
import isPropValid from '@emotion/is-prop-valid';
import { SvgIcon } from 'components/elements/svg-icon/SvgIcon';

interface DropdownButtonProps {
  isOpen: boolean;
  buttonTheme?: string;
}

interface DropdownListItemProps {
  isHighlighted: boolean;
}

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;

export const DropdownLabel = styled.label`
  line-height: 2;
  margin-inline-end: 8px;
  color: ${({ theme }) => theme.palette.neutral.neutral100};
`;

export const DropdownButton = styled.button.withConfig({
  shouldForwardProp: (prop) => isPropValid(prop),
})<DropdownButtonProps>`
  align-items: center;
  border: none;
  cursor: pointer;
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  min-height: 35px;
  padding: 7px 14px 7px 14px;
  text-align: start;
  top: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.neutral.surface};
  border: 1px solid ${({ theme }) => theme.palette.neutral.base};

  ${({ theme, isOpen, buttonTheme }) => {
    switch (buttonTheme) {
      case 'square':
        return `
          padding: 16px;
          border-radius: 4px;
        `;

      default:
        return `

    font-size: ${theme.fontSize[1]}px;
    color: ${theme.palette.neutral.neutral75};
    border-radius: ${
      isOpen
        ? `${theme.borderInputRadius} ${theme.borderInputRadius} 0 0`
        : `${theme.borderInputRadius}`
    };
  `;
    }
  }}

  ${focusOutline({})}
`;

export const DropdownList = styled.ul`
  list-style-type: none;
  max-height: 400px;
  overflow: auto;
  padding-inline-start: 0;
  position: absolute;
  width: 100%;
  top: 100%;
  z-index: 3;
  box-shadow: 0px 3px 7px rgba(33, 33, 33, 0.1);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.neutral.surface};
  ${focusOutline({})}
`;

export const DropdownListItem = styled.li.withConfig({
  shouldForwardProp: (prop) => isPropValid(prop),
})<DropdownListItemProps>`
  background-color: ${({ theme }) => theme.palette.neutral.surface};
  color: ${({ theme }) => theme.palette.neutral.neutral100};
  border-top: none;
  cursor: pointer;
  display: flex;
  font-weight: 400;
  justify-content: space-between;
  padding: 10px 0 10px 10px;

  ${({ isHighlighted, theme }) =>
    isHighlighted &&
    `
    background: ${theme.palette.neutral.base};
  `}
`;

export const DropdownIcon = styled(SvgIcon)`
  &.open {
    transform: rotate(180deg);
  }
`;
